import React, { Component } from 'react';
import parse from 'html-react-parser';
import AcknowlegementIcon from '../atoms/AcknowlegementIcon';

class LocationAcknowledgement extends Component {
  render() {
    if ( this.props.locationData.acknowledgement ) {
      return (
        <>
        <p><AcknowlegementIcon locationColour={this.props.locationColour}/></p>
        <p>
          {parse(this.props.locationData.acknowledgement)}
        </p>
        </>
      )
    } else {
      return null;
    }
  }
}

export default LocationAcknowledgement;
